import { apiFetch } from './client';

/**
 * Main-app session-lifecycle client. `POST /api/auth/logout` deletes the
 * server-side session and clears the `g2_session` cookie (see
 * `api/src/routes/auth.ts`); it is a public route (no session required to
 * call it), so a stale/expired cookie never blocks the request itself.
 */
export const authApi = {
  logout: () => apiFetch<{ ok: boolean }>('/api/auth/logout', { method: 'POST' }),
};
